import { START_TIME_VALUE } from '@/shared/types/basic.ts';

import { useI18n } from '@experience/i18n';
import ru from '../i18n/ru.json';

export const getStartTimeFilterItems = () => {
  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  return {
    MORNING: {
      label: t('morning'),
      description: 'с 6:00 до 12:00',
      value: START_TIME_VALUE.MORNING,
    },
    DAY: {
      label: t('day'),
      description: 'с 12:00 до 17:00',
      value: START_TIME_VALUE.DAY,
    },
    EVENING: {
      label: t('evening'),
      description: 'с 17:00 до 0:00',
      value: START_TIME_VALUE.EVENING,
    },
    NIGHT: {
      label: t('night'),
      description: 'с 0:00 до 6:00',
      value: START_TIME_VALUE.NIGHT,
    },
  };
};
